import {
  StackLayout,
  FormField,
  TextInput,
  Icon,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import {
  FormHandlers,
  PersonalInformationData,
  PersonalInformationDataError,
} from '../../types/onboarding-account-setup-types';

interface PersonalInformationInputProps {
  value: PersonalInformationData;
  onChange: FormHandlers['handlePersonalInformationChange'];
  errors?: PersonalInformationDataError;
}

export const PersonalInformationInput = ({
  errors,
  onChange,
  value,
}: PersonalInformationInputProps) => {
  const { formatMessage } = useIntl();
  return (
    <StackLayout spacing="$one" css={{ width: '100%' }}>
      <FormField
        id="personal-info-first-name"
        label={formatMessage({
          id: 'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_FIRST_NAME_LABEL',
        })}
        name="firstName"
        inputStatus={errors?.firstName ? 'error' : undefined}
        statusMessage={
          errors?.firstName ? formatMessage({ id: errors?.firstName }) : ''
        }
        required
      >
        <TextInput
          value={value.firstName}
          onChange={(e) => onChange('firstName', e.target.value)}
          css={{ '.GDS-base-input': { borderRadius: '$extraLarge' } }}
        />
      </FormField>

      <FormField
        id="personal-info-middle-name"
        label={formatMessage({
          id: 'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_MIDDLE_NAME_LABEL',
        })}
        name="middleName"
      >
        <TextInput
          value={value.middleName}
          onChange={(e) => onChange('middleName', e.target.value)}
          css={{ '.GDS-base-input': { borderRadius: '$extraLarge' } }}
        />
      </FormField>

      <FormField
        id="personal-info-last-name"
        label={formatMessage({
          id: 'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_LAST_NAME_LABEL',
        })}
        name="lastName"
        inputStatus={errors?.lastName ? 'error' : undefined}
        statusMessage={
          errors?.lastName ? formatMessage({ id: errors?.lastName }) : ''
        }
        required
      >
        <TextInput
          value={value.lastName}
          onChange={(e) => onChange('lastName', e.target.value)}
          css={{ '.GDS-base-input': { borderRadius: '$extraLarge' } }}
        />
      </FormField>

      <FormField
        id="personal-info-dob"
        label={formatMessage({
          id: 'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_DOB_LABEL',
        })}
        name="dateOfBirth"
        inputStatus={errors?.dateOfBirth ? 'error' : undefined}
        statusMessage={
          errors?.dateOfBirth ? formatMessage({ id: errors.dateOfBirth }) : ''
        }
        required
      >
        <TextInput
          type="date"
          value={value.dateOfBirth}
          onChange={(e) => onChange('dateOfBirth', e.target.value)}
          placeholder={formatMessage({
            id: 'STR_ONBOARDING_ACCOUNT_SETUP_PERSONAL_INFO_DOB_PLACEHOLDER',
          })}
          leadingContent={<Icon icon="descriptiveCalendar" />}
          //   addOnEndIcon="interfaceChevronDown"
          //   addOnEndIconLabel="Open date picker"
          trailingContent={<Icon icon="interfaceChevronDown" />}
          css={{
            '.GDS-base-input': { borderRadius: '$extraLarge' },
            '::-webkit-calendar-picker-indicator': {
              opacity: 0,
              position: 'absolute',
              right: 0,
              width: '100%',
              height: '100%',
              cursor: 'pointer',
            },
          }}
        />
      </FormField>
    </StackLayout>
  );
};
